import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function TaipeiAreaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🎯 Local SEO Optimization - 強化長尾關鍵字
  useSEO({
    title: '台北搬家公司推薦2025｜台北市搬家費用價格｜大安區信義區中山區搬家｜24小時服務 0978-900-081',
    description: '台北搬家公司推薦首選！建鈞精緻搬家服務台北市12區（大安區、信義區、中山區、內湖區、松山區等），提供套房搬家3000元起、家庭搬遷、辦公室搬遷、鋼琴搬運。10年經驗，4.8分高評價156則好評，透明收費無隱藏費用，學生搬家優惠，老公寓樓梯搬運專業。免費估價：0978-900-081',
    keywords: '台北搬家,台北市搬家公司,台北搬家推薦,台北搬家費用,台北搬家價格,大安區搬家,信義區搬家,中山區搬家,內湖搬家,松山區搬家,台北搬家公司推薦,台北專業搬家,台北搬家多少錢,台北搬家推薦ptt,台北學生搬家,台北套房搬家,台北老公寓搬家,台北搬家便宜,台北搬家評價,台北24小時搬家',
    ogType: 'website',
    ogImage: 'https://public.readdy.ai/ai/img_res/28eafab4cae97adfbc42cb6ebf98f410.jpg'
  });

  // 🎯 Schema.org LocalBusiness Structured Data
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "建鈞精緻搬家 - 台北市搬家服務",
      "image": "https://readdy.ai/api/search-image?query=Taipei%20city%20skyline%20with%20Taipei%20101%20and%20modern%20buildings%2C%20vibrant%20urban%20landscape%20with%20clear%20blue%20sky%2C%20professional%20moving%20services%20concept%20with%20organized%20cityscape&width=1200&height=630&seq=taipei-schema&orientation=landscape",
      "@id": "https://www.example.com/area/taipei",
      "url": "https://www.example.com/area/taipei",
      "telephone": "0978-900-081",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "台北市",
        "addressRegion": "台北市",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 25.0330,
        "longitude": 121.5654
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://line.me/ti/p/@285yavdh"
      ],
      "areaServed": [
        "中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", 
        "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "156"
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const districts = [
    { name: '中正區', features: '總統府、中正紀念堂周邊，老舊公寓多，巷弄狹窄', tips: '注意停車位申請，建議避開觀光時段' },
    { name: '大同區', features: '迪化街、寧夏夜市商圈，傳統住宅區', tips: '老舊建築多，樓梯搬運需更多人力' },
    { name: '中山區', features: '捷運便利，商辦大樓林立', tips: '大樓管理嚴格，需提前預約電梯' },
    { name: '松山區', features: '饒河夜市、民生社區，住商混合', tips: '交通繁忙，建議避開尖峰時段' },
    { name: '大安區', features: '台北精華地段，高級住宅多', tips: '社區規定嚴格，停車困難' },
    { name: '萬華區', features: '龍山寺、西門町商圈，老舊社區多', tips: '巷弄複雜，需熟悉路線' },
    { name: '信義區', features: '101商圈，新興豪宅區', tips: '豪宅管理嚴格，需完整保護措施' },
    { name: '士林區', features: '士林夜市、天母高級住宅區', tips: '山區道路多，注意坡度' },
    { name: '北投區', features: '溫泉區，山坡地形', tips: '山路崎嶇，運輸時間較長' },
    { name: '內湖區', features: '科技園區，新興住宅區', tips: '上下班時段塞車嚴重' },
    { name: '南港區', features: '軟體園區，新建大樓多', tips: '電梯使用頻繁，需預留時間' },
    { name: '文山區', features: '政大、木柵動物園，學區住宅', tips: '山區地形，搬運難度較高' }
  ];

  const services = [
    { icon: 'ri-home-4-line', title: '套房搬遷', desc: '學生、上班族租屋搬家' },
    { icon: 'ri-building-line', title: '家庭搬遷', desc: '公寓、大樓住家搬遷' },
    { icon: 'ri-briefcase-line', title: '辦公室搬遷', desc: '企業、工作室搬遷' },
    { icon: 'ri-music-line', title: '鋼琴搬運', desc: '專業鋼琴搬運服務' }
  ];

  // 🎯 新增：台北搬家常見問題（口語化長尾關鍵字）
  const faqs = [
    {
      question: '台北搬家公司推薦哪一家？PTT網友都推薦誰？',
      answer: '建鈞精緻搬家服務台北市 12 個行政區，4.8 分高評價，156 則客戶好評，提供 24 小時免費估價。深耕台北超過 10 年，熟悉各區特性和交通動線，從大安區豪宅到萬華老公寓都有豐富經驗。許多 PTT 網友推薦我們的透明收費和專業服務。'
    },
    {
      question: '台北搬家費用怎麼算？2025年價格多少？',
      answer: '2025年台北搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），兩房家庭搬家 6,000-8,000 元，三房搬家 10,000-15,000 元，辦公室搬遷 5,000-20,000 元。無電梯老公寓每層加收 500 元，跨區搬家另計距離費。我們提供免費現場估價，確保報價準確透明。'
    },
    {
      question: '台北搬家當天可以預約嗎？急件怎麼辦？',
      answer: '建議提前 3-7 天預約，旺季（週末、月底）建議提前 2 週。如有急件需求（當天或隔天搬家），可來電 0978-900-081 詢問，我們會盡力安排。台北市區交通繁忙，提前預約能確保最佳搬家時段和充足人力。'
    },
    {
      question: '台北市哪些區域搬家比較困難？老公寓怎麼搬？',
      answer: '老舊公寓區（中正、大同、萬華）因無電梯且巷弄狹窄較困難，需要更多人力和時間；山區（北投、士林、文山）因坡度大運輸時間較長；精華區（大安、信義）因停車困難需提前規劃。老公寓搬家我們會安排 3-4 位專業師傅，使用樓梯搬運專業技巧，確保物品和樓梯牆面安全。'
    },
    {
      question: '台北搬家需要申請停車證嗎？怎麼申請？',
      answer: '是的，台北市區停車困難，建議提前 3-7 天向管委會或區公所申請臨時停車證，避免被開罰單（罰款 600-1200 元）。申請方式：1. 社區大樓向管委會申請；2. 路邊停車向區公所申請；3. 需提供搬家日期、車牌號碼、停車位置。我們可以協助您了解申請流程。'
    },
    {
      question: '台北搬家什麼時間最便宜？學生搬家有優惠嗎？',
      answer: '平日（週一至週五）搬家費用較優惠，避開月初月底、週末、國定假日等旺季可省 10-20%。早上 8-9 點開始搬家效率最高。學生搬家我們提供優惠方案，套房搬遷 2,500 元起，提供學生證可享額外折扣。多位同學一起預約還有團體優惠。'
    },
    {
      question: '台北大安區、信義區豪宅搬家要注意什麼？',
      answer: '大安區、信義區豪宅社區管理嚴格，需注意：1. 提前 7-14 天向管委會申請搬家許可；2. 確認電梯使用時間（通常 8:00-17:00）；3. 電梯需做完整保護措施；4. 部分社區收取電梯使用費 500-2000 元；5. 高價物品需特別保護包裝。我們有豐富的豪宅搬家經驗，熟悉各社區規定。'
    },
    {
      question: '台北內湖、南港科技園區搬家方便嗎？',
      answer: '內湖、南港科技園區搬家需注意上下班時段（7-9點、17-19點）塞車嚴重，建議選擇 9:00-16:00 或假日搬家。園區大樓電梯使用頻繁，需提前預約。辦公室搬遷建議選擇週末或夜間，減少對公司營運影響。我們提供 24 小時服務，彈性配合您的時間。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Taipei%20city%20skyline%20with%20Taipei%20101%20and%20modern%20buildings%2C%20vibrant%20urban%20landscape%20with%20clear%20blue%20sky%2C%20professional%20moving%20services%20concept%20with%20organized%20cityscape&width=1920&height=500&seq=taipei001&orientation=landscape"
            alt="台北市搬家服務"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">台北市搬家服務</h1>
          <p className="text-xl mb-8 leading-relaxed">
            深耕台北市10年以上，熟悉各區特性與交通動線<br />
            提供專業、快速、安全的台北搬家服務
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <a href="tel:0978900081" className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
              立即來電諮詢
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* 台北市各區搬家特性 */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北市12行政區搬家指南</h2>
            <p className="text-xl text-gray-600">了解各區特性，提供最適合的搬家方案</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {districts.map((district, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow cursor-pointer">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{district.name}</h3>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">區域特色</p>
                    <p className="text-gray-700">{district.features}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">搬家建議</p>
                    <p className="text-teal-600 font-medium">{district.tips}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 台北搬家服務項目 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北搬家服務項目</h2>
            <p className="text-xl text-gray-600">全方位搬家解決方案，滿足各種需求</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🎯 新增：台北搬家常見問題（口語化） */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-50 to-emerald-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多台北客戶詢問的搬家問題</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-start gap-3">
                  <i className="ri-question-line text-teal-600 text-2xl flex-shrink-0"></i>
                  <span>{faq.question}</span>
                </h3>
                <p className="text-gray-700 leading-relaxed pl-11">{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/faq"
              className="inline-block bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* 台北搬家注意事項 */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北搬家注意事項</h2>
            <p className="text-xl text-gray-600">專業建議，讓您的台北搬家更順利</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-parking-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">停車與交通</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>提前申請臨時停車證，避免被開罰單</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>避開上下班尖峰時段（7-9點、17-19點）</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>市區巷弄狹窄，需確認貨車能否進入</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>捷運站周邊交通繁忙，需預留時間</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-building-2-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">大樓社區規定</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>提前3-7天向管委會申請搬家許可</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>確認電梯使用時間限制（通常8:00-17:00）</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>電梯需做好保護措施，避免損壞</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>部分社區收取電梯使用費或清潔費</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-stairs-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">老舊公寓搬運</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>無電梯公寓需額外收取樓層費</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>樓梯狹窄，大型家具可能需拆卸</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>樓梯搬運需更多人力和時間</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>保護樓梯牆面，避免碰撞損壞</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">最佳搬家時間</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>平日搬家費用較優惠，交通較順暢</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>避開月初月底搬家旺季</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>建議早上8-9點開始，避開中午高溫</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                  <span>雨天搬家需做好防潮措施</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 台北搬家價格參考 */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北搬家價格參考</h2>
            <p className="text-xl text-gray-600">透明收費，絕無隱藏費用</p>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-teal-500 to-teal-600 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-semibold">搬家類型</th>
                    <th className="px-6 py-4 text-left font-semibold">坪數/規模</th>
                    <th className="px-6 py-4 text-left font-semibold">參考價格</th>
                    <th className="px-6 py-4 text-left font-semibold">備註</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">套房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">5-10坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$3,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含基本搬運</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">兩房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">15-25坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$6,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含家具拆裝</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">三房搬遷</td>
                    <td className="px-6 py-4 text-gray-700">30-40坪</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$10,000起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含打包服務</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">辦公室搬遷</td>
                    <td className="px-6 py-4 text-gray-700">依規模</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">現場估價</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">含IT設備搬運</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">鋼琴搬運</td>
                    <td className="px-6 py-4 text-gray-700">直立式/平台式</td>
                    <td className="px-6 py-4 text-teal-600 font-semibold">$3,500起</td>
                    <td className="px-6 py-4 text-gray-600 text-sm">依樓層計價</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                <i className="ri-information-line text-teal-500 mr-2"></i>
                以上價格為參考價格，實際費用依現場評估為準。樓層費、距離費、特殊物品另計。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 相關文章 */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台北搬家知識</h2>
            <p className="text-xl text-gray-600">更多實用的搬家資訊</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/knowledge/article/9" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20moving%20company%20team%20with%20branded%20truck%20and%20equipment%20in%20Taipei%20city%2C%20modern%20urban%20setting%20with%20organized%20moving%20supplies%20and%20friendly%20staff%20members&width=600&height=400&seq=move009&orientation=landscape"
                    alt="台北搬家公司推薦"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    台北搬家公司推薦：如何選擇專業搬家服務
                  </h3>
                  <p className="text-gray-600 mb-4">選擇可靠的台北搬家公司，讓搬家更安心</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>6分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/1" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Organized%20packing%20supplies%20with%20labeled%20boxes%2C%20bubble%20wrap%2C%20tape%20and%20packing%20materials%20arranged%20neatly%2C%20clean%20white%20background%20with%20professional%20moving%20preparation%20setup&width=600&height=400&seq=move001&orientation=landscape"
                    alt="搬家打包技巧"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    搬家前一個月準備清單
                  </h3>
                  <p className="text-gray-600 mb-4">完整的搬家準備流程，讓您不遺漏任何細節</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>8分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/12" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Organized%20packing%20supplies%20with%20labeled%20boxes%2C%20bubble%20wrap%2C%20tape%20and%20packing%20materials%20arranged%20neatly%2C%20clean%20white%20background%20with%20professional%20moving%20preparation%20setup&width=600&height=400&seq=move012&orientation=landscape"
                    alt="打包技巧"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    搬家打包技巧大全
                  </h3>
                  <p className="text-gray-600 mb-4">專業搬家公司的打包秘訣分享</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>8分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">需要台北搬家服務？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            10年以上台北搬家經驗，熟悉各區特性<br />
            專業團隊、透明收費、服務貼心
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <a href="tel:0978900081" className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              0978-900-081
            </a>
            <Link to="/quote" className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
